import { CssSelectors } from '../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

const InterCardSpacing = 10;
export const styleSheet = StyleSheet.create({
	cards: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		marginLeft: -InterCardSpacing,
		marginRight: -InterCardSpacing,
		paddingTop: 20,
		...CssSelectors.allChildren({
			marginBottom: InterCardSpacing,
			marginLeft: InterCardSpacing,
			marginRight: InterCardSpacing,
		}),
	},
	icon: {
		height: 120,
		width: 120,
	},
});
